export default "__VITE_ASSET__169a07a5__"